var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n    Mark\n    "),_c('span',[_vm._v(".")]),_vm._v("\n    Bloomfield\n  ")]),_c('div',[_vm._v("A blog about code")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }